import {
  ShieldCheck,
  CableCar,
  Thermometer,
  Lightbulb,
  Package2,
  MapPin,
} from "lucide-react";

const reasons = [
  {
    icon: ShieldCheck,
    title: "Transparence totale",
    desc: "Devis écrit, prix bloqué, aucun frais caché. Ce qui est validé est ce qui est facturé.",
  },
  {
    icon: CableCar,
    title: "Câblage soigné",
    desc: "Cable management propre inclus. Une machine qui respire et qui se laisse regarder.",
  },
  {
    icon: Thermometer,
    title: "Tests poussés",
    desc: "Stress test CPU/GPU, températures vérifiées, stabilité validée avant livraison.",
  },
  {
    icon: Lightbulb,
    title: "Conseils personnalisés",
    desc: "1080p compétitif, 1440p, 4K, streaming, montage vidéo : la config dépend de votre usage.",
  },
  {
    icon: Package2,
    title: "Sourcing sérieux",
    desc: "Composants neufs, achetés chez des fournisseurs fiables — garanties préservées.",
  },
  {
    icon: MapPin,
    title: "Local & réactif",
    desc: "Atelier à Paris, échanges humains, suivi rapide. Pas de hotline, pas de blabla.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // Pourquoi me choisir
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Un montage de PC,
            <br />
            <span className="text-violet-400">comme s'il était pour moi.</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`reason-card-${i}`}
                className="reveal group relative rounded-2xl border border-white/10 bg-zinc-900/40 p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1 hover:border-violet-400/40 hover:shadow-violet-soft"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-violet-500/40 bg-violet-500/10 group-hover:bg-violet-500/20 transition-colors">
                  <Icon className="h-5 w-5 text-violet-300" />
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">
                  {r.desc}
                </p>
                <div className="absolute inset-x-0 -bottom-px h-px bg-gradient-to-r from-transparent via-violet-500/0 to-transparent group-hover:via-violet-500/60 transition-all" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
